module.exports = __webpack_public_path__ + "static/assets/82a18b84185f2df09d41784e2f989d20.svg";